/** @jsxImportSource @emotion/react */
import { type KeyboardEvent, type ReactNode } from 'react';

import { Card } from '@kaiizen/kai-shiki/react';
import { selectableCardBaseStyle } from './FocusedArtifactPanelStyleLib';

const handleSelectableCardKeyDown = (
  event: KeyboardEvent<HTMLDivElement>,
  onActivate: () => void,
) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  onActivate();
};

/** Shared selectable card chrome for artifact list rows. */
export const ArtifactSelectableCard = ({
  selected,
  children,
  onSelect,
  extraCss,
  title,
}: {
  selected: boolean;
  children: ReactNode;
  onSelect: () => void;
  extraCss?: any;
  title: string;
}) => (
  <Card
    variant='outlined'
    role='button'
    tabIndex={0}
    aria-pressed={selected}
    title={title}
    css={[selectableCardBaseStyle, extraCss]}
    onClick={onSelect}
    onKeyDown={event => handleSelectableCardKeyDown(event, onSelect)}
  >
    {children}
  </Card>
);
